class NotificationPopup extends HTMLElement {

  connectedCallback() {

    this.section = this.closest(".not-pu-section");

    if (!this.section) {
      console.log("IFI POPUP: section not found");
      return;
    }

    this.hasSubscription =
      this.dataset.hasSubscription === "true";

    this.delay =
      Number(this.dataset.delay) || 0;


    /* =========================
       ALREADY SUBSCRIBED
    ========================= */

    if (this.hasSubscription) {
      console.log("IFI POPUP: customer already subscribed");
      return;
    }


    /* =========================
       ALREADY CLOSED
    ========================= */

    if (
      sessionStorage.getItem("ifiPopupClosed") === "true"
    ) {
      console.log("IFI POPUP: already closed in this session");
      return;
    }


    /* =========================
       FIND POPUP
    ========================= */

    this.popup =
      this.section.querySelector(".ifi-popup");

    if (!this.popup) {
      console.log("IFI POPUP: popup box not found");
      return;
    }


    /* =========================
       MOVE POPUP TO BODY
    ========================= */

    if (this.popup.parentElement !== document.body) {
      document.body.appendChild(this.popup);
    }


    /* =========================
       FIND BUTTONS
    ========================= */

    this.closeBtn =
      this.popup.querySelector(".ifi-popup-close");

    this.shopBtn =
      this.popup.querySelector(".ifi-popup-shop");


    console.log("IFI POPUP: showing popup");


    /* =========================
       SHOW AFTER DELAY
    ========================= */

    setTimeout(() => {
      this.showPopup();
    }, this.delay * 1000);


    /* =========================
       CLOSE BUTTON
    ========================= */

    if (this.closeBtn) {

      this.closeBtn.addEventListener(
        "click",
        (event) => {

          event.preventDefault();
          event.stopPropagation();

          this.closePopup();

        }
      );

    }


    /* =========================
       SHOP NOW BUTTON
    ========================= */

    if (this.shopBtn) {

      this.shopBtn.addEventListener(
        "click",
        (event) => {

          event.preventDefault();
          event.stopPropagation();

          console.log(
            "IFI POPUP: SHOP NOW clicked"
          );


          sessionStorage.setItem(
            "ifiPopupClosed",
            "true"
          );


          this.closePopup();


          /* Go to All Products */

          window.location.href =
            "/collections/all";

        }
      );

    }

  }


  /* =====================================================
     SHOW POPUP
  ===================================================== */

  showPopup() {

    if (!this.popup) {
      return;
    }


    /* =========================
       MAIN POPUP
    ========================= */

    this.popup.style.setProperty(
      "position",
      "fixed",
      "important"
    );

    this.popup.style.setProperty(
      "top",
      "50%",
      "important"
    );

    this.popup.style.setProperty(
      "left",
      "50%",
      "important"
    );

    this.popup.style.setProperty(
      "right",
      "auto",
      "important"
    );

    this.popup.style.setProperty(
      "bottom",
      "auto",
      "important"
    );

    this.popup.style.setProperty(
      "transform",
      "translate(-50%, -50%)",
      "important"
    );


    /* =========================
       POPUP SIZE
    ========================= */

    this.popup.style.setProperty(
      "width",
      "500px",
      "important"
    );

    this.popup.style.setProperty(
      "max-width",
      "90vw",
      "important"
    );

    this.popup.style.setProperty(
      "height",
      "auto",
      "important"
    );

    this.popup.style.setProperty(
      "max-height",
      "90vh",
      "important"
    );


    /* =========================
       POPUP BOX
    ========================= */

    this.popup.style.setProperty(
      "margin",
      "0",
      "important"
    );

    this.popup.style.setProperty(
      "padding",
      "0",
      "important"
    );

    this.popup.style.setProperty(
      "overflow",
      "hidden",
      "important"
    );

    this.popup.style.setProperty(
      "box-sizing",
      "border-box",
      "important"
    );

    this.popup.style.setProperty(
      "border-radius",
      "0",
      "important"
    );


    /* =========================
       POPUP LAYER
    ========================= */

    this.popup.style.setProperty(
      "z-index",
      "2147483647",
      "important"
    );

    this.popup.style.setProperty(
      "display",
      "block",
      "important"
    );

    this.popup.style.setProperty(
      "visibility",
      "visible",
      "important"
    );

    this.popup.style.setProperty(
      "opacity",
      "1",
      "important"
    );

    this.popup.style.setProperty(
      "pointer-events",
      "auto",
      "important"
    );


    /* =====================================================
       IMAGE
    ===================================================== */

    const image =
      this.popup.querySelector(
        ".ifi-popup-image img"
      );

    if (image) {

      image.style.setProperty(
        "display",
        "block",
        "important"
      );

      image.style.setProperty(
        "width",
        "100%",
        "important"
      );

      image.style.setProperty(
        "height",
        "auto",
        "important"
      );

      image.style.setProperty(
        "max-width",
        "100%",
        "important"
      );

      image.style.setProperty(
        "max-height",
        "none",
        "important"
      );

      image.style.setProperty(
        "object-fit",
        "contain",
        "important"
      );

      image.style.setProperty(
        "margin",
        "0",
        "important"
      );

    }


    /* =========================
       IMAGE CONTAINER
    ========================= */

    const imageContainer =
      this.popup.querySelector(
        ".ifi-popup-image"
      );

    if (imageContainer) {

      imageContainer.style.setProperty(
        "width",
        "100%",
        "important"
      );

      imageContainer.style.setProperty(
        "height",
        "auto",
        "important"
      );

      imageContainer.style.setProperty(
        "overflow",
        "hidden",
        "important"
      );

      imageContainer.style.setProperty(
        "padding",
        "0",
        "important"
      );

      imageContainer.style.setProperty(
        "margin",
        "0",
        "important"
      );

    }


    /* =====================================================
       CLOSE BUTTON
       
       THIS IS THE IMPORTANT FIX
    ===================================================== */

    if (this.closeBtn) {

      this.closeBtn.style.setProperty(
        "position",
        "absolute",
        "important"
      );

      this.closeBtn.style.setProperty(
        "top",
        "12px",
        "important"
      );

      this.closeBtn.style.setProperty(
        "right",
        "12px",
        "important"
      );

      this.closeBtn.style.setProperty(
        "left",
        "auto",
        "important"
      );

      this.closeBtn.style.setProperty(
        "bottom",
        "auto",
        "important"
      );

      this.closeBtn.style.setProperty(
        "width",
        "38px",
        "important"
      );

      this.closeBtn.style.setProperty(
        "height",
        "38px",
        "important"
      );

      this.closeBtn.style.setProperty(
        "min-width",
        "38px",
        "important"
      );

      this.closeBtn.style.setProperty(
        "min-height",
        "38px",
        "important"
      );

      this.closeBtn.style.setProperty(
        "padding",
        "0",
        "important"
      );

      this.closeBtn.style.setProperty(
        "margin",
        "0",
        "important"
      );

      this.closeBtn.style.setProperty(
        "z-index",
        "20",
        "important"
      );

      this.closeBtn.style.setProperty(
        "display",
        "flex",
        "important"
      );

      this.closeBtn.style.setProperty(
        "align-items",
        "center",
        "important"
      );

      this.closeBtn.style.setProperty(
        "justify-content",
        "center",
        "important"
      );

      this.closeBtn.style.setProperty(
        "border-radius",
        "50%",
        "important"
      );

      this.closeBtn.style.setProperty(
        "background",
        "#ffffff",
        "important"
      );

      this.closeBtn.style.setProperty(
        "color",
        "#111111",
        "important"
      );

      this.closeBtn.style.setProperty(
        "font-size",
        "24px",
        "important"
      );

      this.closeBtn.style.setProperty(
        "line-height",
        "1",
        "important"
      );

      this.closeBtn.style.setProperty(
        "cursor",
        "pointer",
        "important"
      );

      this.closeBtn.style.setProperty(
        "box-sizing",
        "border-box",
        "important"
      );

      this.closeBtn.style.setProperty(
        "visibility",
        "visible",
        "important"
      );

      this.closeBtn.style.setProperty(
        "opacity",
        "1",
        "important"
      );

    }


    /* =====================================================
       SHOP NOW BUTTON
       
       THIS IS THE OTHER IMPORTANT FIX
    ===================================================== */

    if (this.shopBtn) {

      this.shopBtn.style.setProperty(
        "position",
        "absolute",
        "important"
      );

      this.shopBtn.style.setProperty(
        "left",
        "50%",
        "important"
      );

      this.shopBtn.style.setProperty(
        "bottom",
        "14px",
        "important"
      );

      this.shopBtn.style.setProperty(
        "right",
        "auto",
        "important"
      );

      this.shopBtn.style.setProperty(
        "top",
        "auto",
        "important"
      );

      this.shopBtn.style.setProperty(
        "transform",
        "translateX(-50%)",
        "important"
      );

      this.shopBtn.style.setProperty(
        "z-index",
        "20",
        "important"
      );

      this.shopBtn.style.setProperty(
        "display",
        "flex",
        "important"
      );

      this.shopBtn.style.setProperty(
        "align-items",
        "center",
        "important"
      );

      this.shopBtn.style.setProperty(
        "justify-content",
        "center",
        "important"
      );

      this.shopBtn.style.setProperty(
        "width",
        "180px",
        "important"
      );

      this.shopBtn.style.setProperty(
        "max-width",
        "75%",
        "important"
      );

      this.shopBtn.style.setProperty(
        "height",
        "54px",
        "important"
      );

      this.shopBtn.style.setProperty(
        "padding",
        "0 25px",
        "important"
      );

      this.shopBtn.style.setProperty(
        "margin",
        "0",
        "important"
      );

      this.shopBtn.style.setProperty(
        "background",
        "#0878f9",
        "important"
      );

      this.shopBtn.style.setProperty(
        "color",
        "#ffffff",
        "important"
      );

      this.shopBtn.style.setProperty(
        "border",
        "none",
        "important"
      );

      this.shopBtn.style.setProperty(
        "border-radius",
        "30px",
        "important"
      );

      this.shopBtn.style.setProperty(
        "font-size",
        "20px",
        "important"
      );

      this.shopBtn.style.setProperty(
        "font-weight",
        "700",
        "important"
      );

      this.shopBtn.style.setProperty(
        "line-height",
        "1",
        "important"
      );

      this.shopBtn.style.setProperty(
        "cursor",
        "pointer",
        "important"
      );

      this.shopBtn.style.setProperty(
        "box-sizing",
        "border-box",
        "important"
      );

      this.shopBtn.style.setProperty(
        "visibility",
        "visible",
        "important"
      );

      this.shopBtn.style.setProperty(
        "opacity",
        "1",
        "important"
      );

    }


    /* =====================================================
       MOBILE
    ===================================================== */

    if (window.innerWidth <= 600) {

      this.popup.style.setProperty(
        "width",
        "92vw",
        "important"
      );

      this.popup.style.setProperty(
        "max-width",
        "92vw",
        "important"
      );

      this.popup.style.setProperty(
        "max-height",
        "88vh",
        "important"
      );


      /* Mobile close button */

      if (this.closeBtn) {

        this.closeBtn.style.setProperty(
          "top",
          "8px",
          "important"
        );

        this.closeBtn.style.setProperty(
          "right",
          "8px",
          "important"
        );

        this.closeBtn.style.setProperty(
          "width",
          "34px",
          "important"
        );

        this.closeBtn.style.setProperty(
          "height",
          "34px",
          "important"
        );

        this.closeBtn.style.setProperty(
          "min-width",
          "34px",
          "important"
        );

        this.closeBtn.style.setProperty(
          "min-height",
          "34px",
          "important"
        );

        this.closeBtn.style.setProperty(
          "font-size",
          "20px",
          "important"
        );

      }


      /* Mobile Shop Now */

      if (this.shopBtn) {

        this.shopBtn.style.setProperty(
          "bottom",
          "10px",
          "important"
        );

        this.shopBtn.style.setProperty(
          "width",
          "220px",
          "important"
        );

        this.shopBtn.style.setProperty(
          "max-width",
          "70%",
          "important"
        );

        this.shopBtn.style.setProperty(
          "height",
          "46px",
          "important"
        );

        this.shopBtn.style.setProperty(
          "font-size",
          "16px",
          "important"
        );

      }

    }


    console.log(
      "IFI POPUP: visible"
    );

  }


  /* =====================================================
     CLOSE POPUP
  ===================================================== */

  closePopup() {

    if (!this.popup) {
      return;
    }


    sessionStorage.setItem(
      "ifiPopupClosed",
      "true"
    );


    this.popup.style.setProperty(
      "display",
      "none",
      "important"
    );

    this.popup.style.setProperty(
      "visibility",
      "hidden",
      "important"
    );

    this.popup.style.setProperty(
      "opacity",
      "0",
      "important"
    );

    this.popup.style.setProperty(
      "pointer-events",
      "none",
      "important"
    );


    console.log(
      "IFI POPUP: closed for this session"
    );

  }

}


/* =====================================================
   REGISTER CUSTOM ELEMENT
===================================================== */

if (
  !customElements.get(
    "notification-popup"
  )
) {

  customElements.define(
    "notification-popup",
    NotificationPopup
  );

}